import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7FE1CF30-B16F-4626-8450-1881934D2FDF
 * name view-split-horizontal
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-split-horizontal.svg
 * tags
 * - View 
 */
export const ViewSplitHorizontalIcon = createSvgIcon(<><path d="M3,5H21V7H3V5M3,11V9H21V11H3M3,19V13H21V19H3Z" /></>, 'ViewSplitHorizontalIcon');
export default ViewSplitHorizontalIcon